import { render, staticRenderFns } from "./vlc.vue?vue&type=template&id=48807988"
import script from "./vlc.vue?vue&type=script&lang=js"
export * from "./vlc.vue?vue&type=script&lang=js"
import style0 from "./vlc.vue?vue&type=style&index=0&id=48807988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports